import ToolBarButton from 'components/Common/ToolbarButton';
import React from 'react';
import intl from 'react-intl-universal';
import ExportButton from 'components/Common/ExportButton';
import { ButtonType, WaitButton } from 'components/Modal/ModalComponent/WaitButton';

interface Props {
  handleExportData: () => void;
  showAddUserModal: () => void;
  showDeleteConfirmModal: () => void;
  resetExportState: () => void;
  canDelete: boolean;
  hasSelected: boolean;
  isExporting: boolean;
}

class GroupContactsToolbar extends React.PureComponent<Props> {

  componentDidMount(): void {
    this.props.resetExportState();
  }

  render() {
    const { showAddUserModal, handleExportData, canDelete, showDeleteConfirmModal, hasSelected, isExporting } = this.props;

    return (
      <div className="toolbar" data-test="toolbar">
        <div>
          <ExportButton
            disabled={false}
            onExportClick={handleExportData}
            isExporting={isExporting}
          />
          <WaitButton
            buttonText={intl.get('addGroupContact')}
            isBusy={false}
            isDisabled={false}
            isSubmitButton={true}
            onSave={showAddUserModal}
            type={ButtonType.button}
          />
          <ToolBarButton
            clickHandler={showDeleteConfirmModal}
            disabledTooltipText={intl.get('tooltipNoneSelectedGroupContacts')}
            isEnabled={canDelete}
            label={intl.get('delete')}
            showWarningText={!canDelete && hasSelected}
            tooltipIsOnRight={true}
            warningTooltipText={intl.get('tooltipDelete')}
          />
        </div>
      </div>
    );
  }
}

export default GroupContactsToolbar;
